<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="银行" prop="backName">
            <el-input v-model="queryForm.backName" placeholder="请输入银行名"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="银行卡号" prop="backCardNum">
            <el-input v-model="queryForm.backCardNum" placeholder="请输入银行卡号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="审核状态" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择审核类型">
              <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.value"
                  :value="item.flag"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="1">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-button type="success" size="small" style="margin: 0 0 10px 20px"
               @click="handleReview()">批量通过</el-button>
    <el-table :data="tableData"
              ref="table"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              style="width: 100%;margin-bottom: 20px;"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="id" width="170" label="序号" />
      <el-table-column prop="userName"  label="所属商家" />
      <el-table-column prop="backName"  label="银行" />
      <el-table-column prop="backCardNum" width="210" label="银行卡号" />
      <el-table-column prop="backCardName" label="开户姓名" />
      <el-table-column prop="backOpenAdress" label="开户行" />
      <el-table-column prop="isDefault" label="是否默认" width="150" align="center">
        <template slot-scope="scope">
          <el-switch
              active-text ="是"
              inactive-text = "否"
              v-model="scope.row.isDefault"
              @change=changeEnabled(scope.$index,scope.row)
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="审核状态" width="120" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.status?'审核通过':'审核未通过'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="添加时间" />
      <el-table-column prop="updateTime" width="120" label="更新时间" />
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="240" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary"
                     @click="handleEditCard(scope.$index, scope.row,'编辑银行卡')">
            编辑
          </el-button>
          <el-button size="mini" type="danger"
                     @click="handleDelete(scope.$index, scope.row)">
            删除
          </el-button>
          <el-button v-if="!scope.row.status" size="mini" type="success"
                     @click="handleEdit(scope.$index, scope.row,'银行卡审核')">
            审核
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>

  <el-dialog :title="dialogTitle"
             :visible.sync="dialogFormVisible"
             :before-close="beforeDialogClose"
             style="text-align: center">
    <el-form ref="dialogForm" :model="dialogForm" label-width="20%">
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="审核状态:" label-width="30%">
          <el-select v-model="dialogForm.status" clearable placeholder="审核状态" style="width: 80%">
            <el-option
                v-for="item in statusOptions"
                :key="item.id"
                :label="item.value"
                :value="item.flag"
            >
            </el-option>
          </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="审核原因:" label-width="30%">
          <el-input v-model="dialogForm.remarks" placeholder="审核原因"
                    style="width: 80%;margin-top: 20px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogForm()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogEditTitle"
             :visible.sync="dialogFormEditVisible"
             style="text-align: center">
    <el-form ref="dialogEditForm" :model="dialogEditForm" >
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="选择银行:" label-width="30%">
          <el-select v-model="dialogEditForm.backName" clearable placeholder="请选择银行" style="width: 80%">
            <el-option
                v-for="item in backOptions"
                :key="item.id"
                :label="item.backName"
                :value="item.backName"
            >
            </el-option>
          </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="开户行:" label-width="30%">
          <el-input v-model="dialogEditForm.backName" placeholder="开户行(非必填)"
                    style="width: 80%;margin-top: 20px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="开户人姓名:" label-width="30%">
          <el-input v-model="dialogEditForm.backCardName" placeholder="开户人姓名"
                    style="width: 80%;margin-top: 20px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="银行卡号:" label-width="30%">
          <el-input type="number" v-model="dialogEditForm.backCardNum" placeholder="银行卡号(输入数字)" style="width: 80%;margin-top: 20px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitEditDialogForm()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleEditCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {getAllB2cBackInfos, getB2cBackCard, updateB2cBackCard, deleteB2cBackCard, updateB2cBackCardBatch} from "../../api/b2cbusiness/b2c_backcardmanage";
import MinxinScroll from "@/components/MinxinScroll";

export default {
  name: "BackCardlist",
  mixins:[MixinCUD, MinxinScroll],
  data(){
    return {
      selecteds:[],
      tableData:[],
      queryForm: {
        id: null,
        backNamed: '',
        backCardNum: '',
        backCardName: '',
        backOpenAdress: '',
        isDefault: '',
        status: ''
      },
      queryFormRefName:"queryForm",
      backOptions:[],
      statusOptions: [
        {
          flag:true ,
          value:"审核通过",
        },
        {
          flag: false ,
          value:"审核未通过",
        }
      ],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
      },
      dialogFormEditVisible: false,
      dialogEditTitle: "",
      dialogEditRefName: "dialogEditForm",
      dialogEditForm:{
      },
      tableHeight: 850,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    //this.tableHeight = document.body.clientHeight - 220;
    this.getData();
    this.getAllBackInfos();
  },
  methods: {
    submitDialogForm(){
      this.$refs[this.dialogRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                if(this.dialogForm.id){ //有id是更新数据，没有id是新增数据
                  this.updateData();
                }else {
                  updateB2cBackCardBatch(this.dialogForm).then(res => {
                    this.$message({message: res.data, type: 'success'});
                    this.submitQueryForm();//修改之后，重新查询table
                    this.handleCloseDialog();
                  });
                }
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    handleSelectionChange(val){
      this.selecteds = val;
      console.log(this.selecteds)
    },
    handleReview(){
      this.dialogFormVisible = true;
      this.dialogTitle = "批量审批";
      this.resetDialogForm();
      this.dialogForm = {status:this.dialogForm.status, b2cBackCards:this.selecteds};
    },
    submitEditDialogForm(){
      this.$refs[this.dialogEditRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                if(this.dialogEditForm.id){ //有id是更新数据，没有id是新增数据
                  this.updateData();
                }
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleEditCloseDialog();});
        } else {
          return false;
        }
      });
    },
    handleEditCloseDialog(){
      //resetFields就是一个坑，有两个作用
      //1.重置的值不是空的，而是第一次被赋予的值。
      //第一次dialogForm赋空值，后续才能重置为空值。
      //这就是我们在新增修改打开弹出框操作的时候，调用resetDialogFrom清空数据的原因。
      //2.清空校验结果
      this.$refs[this.dialogEditRefName].resetFields();
      this.dialogFormEditVisible = false;
    },
    resetDialogEditForm(){
      for(let item in this.dialogForm){
        if (typeof this.dialogEditForm[item]==='string'){
          this.dialogEditForm[item]='';
        } else if (this.dialogEditForm[item] instanceof Array) {
          this.dialogEditForm[item]=[];
        } else{
          this.dialogEditForm[item]=null
        }
      }
    },
    handleEditCard(index, row,dialogTitle) {
      this.dialogFormEditVisible = true;
      this.dialogEditTitle = dialogTitle
      this.resetDialogEditForm()
      this.dialogEditForm = {...row}
    },
    getAllBackInfos(){
      getAllB2cBackInfos().then(res=>{
        console.log(res.data);
        if (res.success){
          this.backOptions = res.data;
        }
      });
    },
    updateData(){
      if (this.dialogForm.id) {
        updateB2cBackCard(this.dialogForm)
            .then(res => {
              this.$message({message: res.data, type: 'success'});
              this.submitQueryForm();//修改之后，重新查询table
              this.handleCloseDialog();
            });
      }else{
        updateB2cBackCard(this.dialogEditForm)
            .then(res => {
              this.$message({message: res.data, type: 'success'});
              this.submitQueryForm();//修改之后，重新查询table
              this.handleEditCloseDialog();
            });
      }
    },
    deleteData(row){
      this.$confirm("确定删除["+row.backName+"]?")
          .then(_ => {
            deleteB2cBackCard(row.id)
                .then(res => {
                  this.submitQueryForm();//删除之后，重新查询table
                  this.$message({message: res.data, type: 'success'});
                }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            })
          });
    },
    getData(){
      console.log(this.queryForm)
      this.queryForm.isPlateformAccount = false;
      getB2cBackCard(this.queryForm, this.pagination).then(res=>{
        this.setData(res);
      });
    },
    setData(pageInfos){
      console.log(pageInfos.data)
      if (pageInfos.success){
        this.tableData = pageInfos.data.records;
        this.pagination.pageNum = pageInfos.data.current;
        this.pagination.pageSize = pageInfos.data.size;
        this.pagination.total = pageInfos.data.total;
      }
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
